module.exports = __webpack_public_path__ + "static/media/b1.12a7d7b4.jpg";